export const metricsMessages = {
  title: 'Referral Program Metrics',
  loadingFailedErrorMessage: 'Something went wrong. Please try again.',
};
